<template>
    <div class="article-home">
        <ul>
            <li>Serverless rendering</li>
            <li>Low maintenance requirements</li>
            <li>Search engine ready</li>
            <li>Scales to serve any traffic</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ArticleHome',
};
</script>
